import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Phone, ClipboardList } from "lucide-react";
export default function HeroSection() {
  return;
}